"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const CollapseList = /*#__PURE__*/_react.default.forwardRef(({
  children,
  ...restProps
}, ref) => {
  return (0, _jsxRuntime.jsx)("div", {
    ref: ref,
    css: theme => [_styles.styles.default(theme)],
    ...restProps,
    children: children
  });
});
var _default = exports.default = CollapseList;